import React, { Component } from 'react';

class Notifikasi extends Component {
    render() {
        return (
            <li className="nav-item dropdown">
                <a className="nav-link count-indicator dropdown-toggle" id="notificationDropdown" href="#" data-toggle="dropdown">
                    <i className="icon-bell mx-0" />
                    <span className="count" />
                </a>
                <div className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" aria-labelledby="notificationDropdown">
                    <p className="mb-0 font-weight-normal float-left dropdown-header hitam">Notifikasi</p>
                    <a className="dropdown-item preview-item">
                        <div className="preview-thumbnail">
                            <div className="preview-icon bg-success">
                                <i className="ti-info-alt mx-0" />
                            </div>
                        </div>
                        <div className="preview-item-content">
                            <h6 className="preview-subject font-weight-normal">-</h6>
                            <p className="font-weight-light small-text mb-0 text-muted">
                                -
                            </p>
                        </div>
                    </a>
                </div>
            </li>
        );
    }
}

export default Notifikasi;